"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardFilter = void 0;
const baseFilter_1 = require("./baseFilter");
class DashboardFilter extends baseFilter_1.BaseFilter {
    constructor(dashboardFilter) {
        super(dashboardFilter.id, dashboardFilter.name, dashboardFilter.type, dashboardFilter.default_value, dashboardFilter.model, dashboardFilter.explore, dashboardFilter.dimension);
        this.dashboardId = dashboardFilter.dashboard_id;
        this.title = dashboardFilter.title;
        this.row = dashboardFilter.row;
        this.listenToFilters = dashboardFilter.listen_to_filters;
        this.allowMultipleValues = dashboardFilter.allow_multiple_values;
        this.required = dashboardFilter.required;
        this.defaultValues = dashboardFilter?.default_value?.split(',');
        this.uiConfig = dashboardFilter.ui_config;
    }
    static get QUERY_FIELDS() {
        return `${baseFilter_1.BaseFilter.QUERY_FIELDS},dashboard_id,title,allow_multiple_values,ui_config`;
    }
}
exports.DashboardFilter = DashboardFilter;
